import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubdomainService } from '../services/subdomain.service';

@Injectable()
export class SubdomainInterceptor implements HttpInterceptor {
    private subdomainService = inject(SubdomainService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const subdomain = this.subdomainService.getSubdomain();
        // Clone the request to add the new header
        const modifiedReq = req.clone({
            withCredentials: true,
            setHeaders: {
                Subdomain: subdomain || '', // Provide a default value if subdomain is empty
            },
        });

        // Pass the modified request to the next handler
        return next.handle(modifiedReq);
    }
}
